import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import TextField from '@ep/components/TextField';
import theme from '@ep/theme';
import { __EnumValue } from 'graphql';
import React, { useState } from 'react';

const StyledContainer = styled(Container)`
  display: grid;
  max-width: 80rem;
  ${theme.mediaQueries.desktop} {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  ${theme.mediaQueries.mobileAndTablet} {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  #content {
  }
  #controls {
    margin: 0rem auto;
  }
  #controlsInner {
  }
  .option {
    min-height: 5rem;
  }
  #results {
    margin: auto auto;
  }
  #resultsInner {
  }
  #bottom {
    grid-column: 1 / span 2;
    ${theme.mediaQueries.mobileAndTablet} {
      grid-column: 1 / span 1;
    }
  }
  h1 {
    margin-top: 5rem;
    font-family: ${theme.typography.primaryFont.bold};
    color: ${theme.colors.duskBlue};
    font-size: 1.8rem;
  }
  hr {
    border: 0px solid white;
    border-top: 0.5px solid ${theme.colors.gray};
  }
  td {
    vertical-align: top;
  }
  input,
  p,
  select {
    margin-top: 1rem;
    font-size: 1.2em;
    padding: 10px;
    border-radius: 10px;
    font-family: ${theme.typography.primaryFont.regular};
  }
  select {
    width: 25rem;
    border: 1px solid ${theme.colors.gray};
    margin-bottom: 1.4rem;
    padding: 10px;
    ${theme.mediaQueries.mobile} {
      width: 18rem;
    }
  }
  input {
    border: 0px solid white;
    color: black;
    font-weight: normal;
  }
  input#qsGoodsAndServ,
  input#qsResAtl,
  input#qsResBtl,
  input#qsNonResAtl,
  input#qsNonResBtl {
    padding-left: 1rem;
    width: 23rem;
    ${theme.mediaQueries.mobile} {
      width: 18rem;
    }
  }
  .total {
    font-family: ${theme.typography.primaryFont.light};
    font-weight: normal;
    color: ${theme.colors.mantisGreen};
    font-size: 6rem;
    line-height: 5rem;
    margin-bottom: 2rem;
  }
  .estimatedSavingsCell {
    text-align: center;
  }
  .estimatedSavings {
    color: ${theme.colors.darkGray};
    font-size: 2.5rem;
  }
  .spendAlert {
    width: 100%;
    background-color: white;
    color: ${theme.colors.darkGray};
    text-align: center;
    font-style: italic;
    font-size: 2.2rem;
  }
  .msg {
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    font-size: 2.2rem;
    margin-bottom: 5rem;
  }
  .result {
    padding-left: 10px;
    margin-left: 0px;
    color: black;
  }
  .calculator {
    padding: 20px;
    border-radius: 10px;
    margin: auto auto;
    width: 70%;
  }
  .selector {
    text-align: center;
  }
`;

const StyledTextField = styled(TextField)`
  border-radius: 10px;
  border: 1px solid ${theme.colors.gray};
  margin-bottom: 1.5rem;
  .MuiInputBase-root {
    border-radius: 10px;
    height: 4.5rem;
  }
`;

// ----------------------------------------
// RENDER MODULE
// ----------------------------------------
function IncentiveEstimatorModuleUS() {
  const [output, setOutput] = useState({
    state_r: '',
    displayOption_r: false,
    optionLabelLeft_r: 'Feature',
    optionLabelRight_r: 'TV',
    message_r: '',
    spendAlert_r: '',
    minSpendFeature_r: '0',
    capFeature_r: '0',
    minSpendTv_r: '0',
    capTv_r: '0',
    qsGoodsAndServ_r: '0',
    qsResAtl_r: '0',
    qsResBtl_r: '0',
    qsNonResAtl_r: '0',
    qsNonResBtl_r: '0',
    goodsAndServ_r: '0',
    resAtl_r: '0',
    resBtl_r: '0',
    nonResAtl_r: '0',
    nonResBtl_r: '0',
    total_r: '0',
  });

  // ----------------------------------------
  // GET RADIO VALUE
  // ----------------------------------------
  /* string */ function getRadioValue() {
    var selectedOption = 'left';
    var option = document.getElementsByName('option');
    for (var i = 0, length = option.length; i < length; i++) {
      if (option[i].checked) {
        if (option[i].value == 'left') {
          selectedOption = 'left';
        } else {
          selectedOption = 'right';
        }
      }
    }
    return selectedOption;
  }

  // ----------------------------------------
  // DEFINE INCENTIVES FOR STATE
  // ----------------------------------------
  /* void */ function defineIncentivesForState(state: string) {
    let featOrTv = getRadioValue();
    // ----------------------------------------
    // TOTAL SPEND EQUALS SUM OF SAVED VALUES
    // FROM LEFT COLUMN
    // ----------------------------------------
    let totalSpend =
      parseFloat(
        output.qsGoodsAndServ_r
          ? output.qsGoodsAndServ_r.replace(/,/g, '')
          : '0',
      ) +
      parseFloat(
        output.qsResAtl_r ? output.qsResAtl_r.replace(/,/g, '') : '0',
      ) +
      parseFloat(
        output.qsResBtl_r ? output.qsResBtl_r.replace(/,/g, '') : '0',
      ) +
      parseFloat(
        output.qsNonResAtl_r ? output.qsNonResAtl_r.replace(/,/g, '') : '0',
      ) +
      parseFloat(
        output.qsNonResBtl_r ? output.qsNonResBtl_r.replace(/,/g, '') : '0',
      );
    // ----------------------------------------
    // CREATE OBJECTS
    // ----------------------------------------
    let al = {
      abbrev: 'AL',
      goodsAndServ: 25,
      resAtl: 35,
      resBtl: 35,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 500000,
      capFeature: 20000000,
      minSpendTv: 500000,
      capTv: 20000000,
      msg: '',
    };
    let ak = {
      abbrev: 'AK',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 200000,
      capFeature: 0,
      minSpendTv: 200000,
      capTv: 0,
      msg: '',
    };
    let az = {
      abbrev: 'AZ',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ar = {
      abbrev: 'AR',
      goodsAndServ: 25,
      resAtl: 25,
      resBtl: 30,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ca1 = {
      abbrev: 'CA1',
      goodsAndServ: 25,
      resAtl: 0,
      resBtl: 25,
      nonResAtl: 0,
      nonResBtl: 25,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: 'Minimum production budget of $1M required',
    };
    let ca2 = {
      abbrev: 'CA2',
      goodsAndServ: 20,
      resAtl: 0,
      resBtl: 20,
      nonResAtl: 0,
      nonResBtl: 20,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: 'Minimum production budget of $1M required',
    };
    let ca3 = {
      abbrev: 'CA3',
      goodsAndServ: 25,
      resAtl: 0,
      resBtl: 25,
      nonResAtl: 0,
      nonResBtl: 25,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: 'Minimum production budget of $1M required',
    };
    let ca4 = {
      abbrev: 'CA4',
      goodsAndServ: 20,
      resAtl: 0,
      resBtl: 20,
      nonResAtl: 0,
      nonResBtl: 20,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: 'Minimum production budget of $1M required',
    };
    let co = {
      abbrev: 'CO',
      goodsAndServ: 20,
      resAtl: 20,
      resBtl: 20,
      nonResAtl: 20,
      nonResBtl: 20,
      minSpendFeature: 1000000,
      capFeature: 0,
      minSpendTv: 1000000,
      capTv: 0,
      msg: '',
    };
    let ct = {
      abbrev: 'CT',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 100000,
      capFeature: 0,
      minSpendTv: 100000,
      capTv: 0,
      msg: '',
    };
    let dc = {
      abbrev: 'DC',
      goodsAndServ: 35,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 10,
      nonResBtl: 10,
      minSpendFeature: 250000,
      capFeature: 0,
      minSpendTv: 250000,
      capTv: 0,
      msg: '',
    };
    let de = {
      abbrev: 'DE',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let fl = {
      abbrev: 'FL',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ga = {
      abbrev: 'GA',
      goodsAndServ: 30,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 30,
      nonResBtl: 30,
      minSpendFeature: 500000,
      capFeature: 0,
      minSpendTv: 500000,
      capTv: 0,
      msg: 'Includes 10% GEP Uplift',
    };
    let hi = {
      abbrev: 'HI',
      goodsAndServ: 22,
      resAtl: 22,
      resBtl: 22,
      nonResAtl: 22,
      nonResBtl: 22,
      minSpendFeature: 100000,
      capFeature: 15000000,
      minSpendTv: 100000,
      capTv: 15000000,
      msg: '',
    };
    let id = {
      abbrev: 'ID',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let il = {
      abbrev: 'IL',
      goodsAndServ: 30,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 100000,
      capFeature: 0,
      minSpendTv: 100000,
      capTv: 0,
      msg: '',
    };
    let inn = {
      abbrev: 'INN',
      goodsAndServ: 20,
      resAtl: 20,
      resBtl: 25,
      nonResAtl: 20,
      nonResBtl: 20,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ia = {
      abbrev: 'IA',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ks = {
      abbrev: 'KS',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ky = {
      abbrev: 'KY',
      goodsAndServ: 30,
      resAtl: 35,
      resBtl: 35,
      nonResAtl: 30,
      nonResBtl: 30,
      minSpendFeature: 250000,
      capFeature: 0,
      minSpendTv: 250000,
      capTv: 0,
      msg: '',
    };
    let la = {
      abbrev: 'LA',
      goodsAndServ: 25,
      resAtl: 40,
      resBtl: 40,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 300000,
      capFeature: 20000000,
      minSpendTv: 300000,
      capTv: 25000000,
      msg: 'Loan-Out payments qualify at 25%',
    };
    let me = {
      abbrev: 'ME',
      goodsAndServ: 5,
      resAtl: 12,
      resBtl: 12,
      nonResAtl: 10,
      nonResBtl: 10,
      minSpendFeature: 75000,
      capFeature: 0,
      minSpendTv: 75000,
      capTv: 0,
      msg: '',
    };
    let md = {
      abbrev: 'MD',
      goodsAndServ: 28,
      resAtl: 28,
      resBtl: 28,
      nonResAtl: 28,
      nonResBtl: 28,
      minSpendFeature: 250000,
      capFeature: 10000000,
      minSpendTv: 250000,
      capTv: 10000000,
      msg: '',
    };
    let ma = {
      abbrev: 'MA',
      goodsAndServ: 25,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 50000,
      capFeature: 0,
      minSpendTv: 50000,
      capTv: 0,
      msg: '',
    };
    let mi = {
      abbrev: 'MI',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let mn = {
      abbrev: 'MN',
      goodsAndServ: 0,
      resAtl: 20,
      resBtl: 20,
      nonResAtl: 20,
      nonResBtl: 15,
      minSpendFeature: 100000,
      capFeature: 0,
      minSpendTv: 100000,
      capTv: 0,
      msg: '',
    };
    let ms = {
      abbrev: 'MS',
      goodsAndServ: 25,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 50000,
      capFeature: 10000000,
      minSpendTv: 50000,
      capTv: 10000000,
      msg: '',
    };
    let mo = {
      abbrev: 'MO',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let mt = {
      abbrev: 'MT',
      goodsAndServ: 20,
      resAtl: 20,
      resBtl: 25,
      nonResAtl: 20,
      nonResBtl: 15,
      minSpendFeature: 350000,
      capFeature: 10000000,
      minSpendTv: 350000,
      capTv: 10000000,
      msg: '',
    };
    let ne = {
      abbrev: 'NE',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let nv = {
      abbrev: 'NV',
      goodsAndServ: 15,
      resAtl: 15,
      resBtl: 15,
      nonResAtl: 0,
      nonResBtl: 12,
      minSpendFeature: 500000,
      capFeature: 6000000,
      minSpendTv: 500000,
      capTv: 6000000,
      msg: '',
    };
    let nh = {
      abbrev: 'NH',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let nj = {
      abbrev: 'NJ',
      goodsAndServ: 30,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 30,
      nonResBtl: 30,
      minSpendFeature: 1000000,
      capFeature: 0,
      minSpendTv: 1000000,
      capTv: 0,
      msg: '',
    };
    let nm = {
      abbrev: 'NM',
      goodsAndServ: 25,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 25,
      nonResBtl: 15,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: 'Contact EP for more information on qualifying non-residents',
    };
    let ny = {
      abbrev: 'NY',
      goodsAndServ: 30,
      resAtl: 0,
      resBtl: 30,
      nonResAtl: 0,
      nonResBtl: 30,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let nc = {
      abbrev: 'NC',
      goodsAndServ: 25,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 3000000,
      capFeature: 7000000,
      minSpendTv: 1000000,
      capTv: 12000000,
      msg: '',
    };
    let nd = {
      abbrev: 'ND',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let oh = {
      abbrev: 'OH',
      goodsAndServ: 30,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 30,
      nonResBtl: 30,
      minSpendFeature: 300000,
      capFeature: 0,
      minSpendTv: 300000,
      capTv: 0,
      msg: '',
    };
    let ok = {
      abbrev: 'OK',
      goodsAndServ: 20,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 25,
      nonResBtl: 20,
      minSpendFeature: 50000,
      capFeature: 0,
      minSpendTv: 50000,
      capTv: 0,
      msg: '',
    };
    let or = {
      abbrev: 'OR',
      goodsAndServ: 25,
      resAtl: 26.2,
      resBtl: 26.2,
      nonResAtl: 26.2,
      nonResBtl: 26.2,
      minSpendFeature: 1000000,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let pa = {
      abbrev: 'PA',
      goodsAndServ: 25,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 25,
      nonResBtl: 25,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '60% of total production expenditures must be incurred in PA',
    };
    let pr = {
      abbrev: 'PR',
      goodsAndServ: 40,
      resAtl: 40,
      resBtl: 40,
      nonResAtl: 20,
      nonResBtl: 20,
      minSpendFeature: 50000,
      capFeature: 0,
      minSpendTv: 50000,
      capTv: 0,
      msg: '',
    };
    let ri = {
      abbrev: 'RI',
      goodsAndServ: 30,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 30,
      nonResBtl: 30,
      minSpendFeature: 100000,
      capFeature: 7000000,
      minSpendTv: 100000,
      capTv: 7000000,
      msg: '',
    };
    let sc = {
      abbrev: 'SC',
      goodsAndServ: 30,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 20,
      nonResBtl: 20,
      minSpendFeature: 1000000,
      capFeature: 0,
      minSpendTv: 1000000,
      capTv: 0,
      msg: '',
    };
    let sd = {
      abbrev: 'SD',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let tn = {
      abbrev: 'TN',
      goodsAndServ: 25,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 200000,
      capFeature: 0,
      minSpendTv: 500000,
      capTv: 0,
      msg: '',
    };
    let tx = {
      abbrev: 'TX',
      goodsAndServ: 20,
      resAtl: 20,
      resBtl: 20,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 250000,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let ut = {
      abbrev: 'UT',
      goodsAndServ: 20,
      resAtl: 20,
      resBtl: 20,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 500000,
      capFeature: 0,
      minSpendTv: 500000,
      capTv: 0,
      msg: '',
    };
    let vt = {
      abbrev: 'VT',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let va = {
      abbrev: 'VA',
      goodsAndServ: 15,
      resAtl: 25,
      resBtl: 25,
      nonResAtl: 15,
      nonResBtl: 15,
      minSpendFeature: 250000,
      capFeature: 0,
      minSpendTv: 250000,
      capTv: 0,
      msg: '',
    };
    let wa = {
      abbrev: 'WA',
      goodsAndServ: 30,
      resAtl: 30,
      resBtl: 30,
      nonResAtl: 0,
      nonResBtl: 15,
      minSpendFeature: 500000,
      capFeature: 0,
      minSpendTv: 300000,
      capTv: 0,
      msg: '',
    };
    let wd = {
      abbrev: 'WD',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let wi = {
      abbrev: 'WI',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    let wy = {
      abbrev: 'WY',
      goodsAndServ: 0,
      resAtl: 0,
      resBtl: 0,
      nonResAtl: 0,
      nonResBtl: 0,
      minSpendFeature: 0,
      capFeature: 0,
      minSpendTv: 0,
      capTv: 0,
      msg: '',
    };
    // ----------------------------------------
    // CONNECTICUT EXCEPTION
    // BASED ON TOTAL SPEND
    // ----------------------------------------
    var ctTotal = totalSpend;
    if (ctTotal <= 499999) {
      ct = {
        abbrev: 'CT',
        goodsAndServ: 10,
        resAtl: 10,
        resBtl: 10,
        nonResAtl: 10,
        nonResBtl: 10,
        minSpendFeature: 100000,
        capFeature: 0,
        minSpendTv: 100000,
        capTv: 0,
        msg: '',
      };
    }
    if (ctTotal >= 500000 && ctTotal <= 999999) {
      ct = {
        abbrev: 'CT',
        goodsAndServ: 15,
        resAtl: 15,
        resBtl: 15,
        nonResAtl: 15,
        nonResBtl: 15,
        minSpendFeature: 100000,
        capFeature: 0,
        minSpendTv: 100000,
        capTv: 0,
        msg: '',
      };
    }
    if (ctTotal >= 1000000) {
      ct = {
        abbrev: 'CT',
        goodsAndServ: 30,
        resAtl: 30,
        resBtl: 30,
        nonResAtl: 30,
        nonResBtl: 30,
        minSpendFeature: 100000,
        capFeature: 0,
        minSpendTv: 100000,
        capTv: 0,
        msg: '',
      };
    }
    // ----------------------------------------
    // DC EXCEPTION
    // BASED ON USER SELECTION LEFT OR RIGHT
    // ----------------------------------------
    if (featOrTv == 'left') {
      dc = {
        abbrev: 'DC',
        goodsAndServ: 35,
        resAtl: 30,
        resBtl: 30,
        nonResAtl: 10,
        nonResBtl: 10,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 250000,
        capTv: 0,
        msg: '',
      };
    } else {
      dc = {
        abbrev: 'DC',
        goodsAndServ: 21,
        resAtl: 30,
        resBtl: 30,
        nonResAtl: 10,
        nonResBtl: 10,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 250000,
        capTv: 0,
        msg: '',
      };
    }
    // ----------------------------------------
    // MD EXCEPTION
    // BASED ON USER SELECTION LEFT OR RIGHT
    // ----------------------------------------
    if (featOrTv == 'left') {
      md = {
        abbrev: 'MD',
        goodsAndServ: 28,
        resAtl: 28,
        resBtl: 28,
        nonResAtl: 28,
        nonResBtl: 28,
        minSpendFeature: 250000,
        capFeature: 10000000,
        minSpendTv: 250000,
        capTv: 10000000,
        msg: '',
      };
    } else {
      md = {
        abbrev: 'MD',
        goodsAndServ: 30,
        resAtl: 30,
        resBtl: 30,
        nonResAtl: 30,
        nonResBtl: 30,
        minSpendFeature: 250000,
        capFeature: 10000000,
        minSpendTv: 250000,
        capTv: 10000000,
        msg: '',
      };
    }
    // ----------------------------------------
    // MN EXCEPTION
    // BASED ON TOTAL SPEND
    // ----------------------------------------
    // let mnTotal = totalSpend;
    // if (mnTotal <= 99999) {
    //   mn = {
    //     abbrev: 'MN',
    //     goodsAndServ: 0,
    //     resAtl: 0,
    //     resBtl: 0,
    //     nonResAtl: 0,
    //     nonResBtl: 0,
    //     minSpendFeature: 100000,
    //     capFeature: 0,
    //     minSpendTv: 100000,
    //     capTv: 0,
    //     msg: '',
    //   };
    // }
    // if (mnTotal >= 100000 && mnTotal <= 999999) {
    //   mn = {
    //     abbrev: 'MN',
    //     goodsAndServ: 20,
    //     resAtl: 20,
    //     resBtl: 20,
    //     nonResAtl: 20,
    //     nonResBtl: 20,
    //     minSpendFeature: 100000,
    //     capFeature: 0,
    //     minSpendTv: 100000,
    //     capTv: 0,
    //     msg: '',
    //   };
    // }
    // if (mnTotal >= 1000000) {
    //   mn = {
    //     abbrev: 'MN',
    //     goodsAndServ: 25,
    //     resAtl: 25,
    //     resBtl: 25,
    //     nonResAtl: 25,
    //     nonResBtl: 25,
    //     minSpendFeature: 100000,
    //     capFeature: 0,
    //     minSpendTv: 100000,
    //     capTv: 0,
    //     msg: '',
    //   };
    // }
    if (featOrTv == 'left') {
      mn = {
        abbrev: 'MN',
        goodsAndServ: 20,
        resAtl: 20,
        resBtl: 20,
        nonResAtl: 20,
        nonResBtl: 15,
        minSpendFeature: 100000,
        capFeature: 0,
        minSpendTv: 100000,
        capTv: 0,
        msg: '',
      };
    } else {
      mn = {
        abbrev: 'MN',
        goodsAndServ: 20,
        resAtl: 20,
        resBtl: 20,
        nonResAtl: 20,
        nonResBtl: 15,
        minSpendFeature: 1000000,
        capFeature: 0,
        minSpendTv: 1000000,
        capTv: 0,
        msg: '',
      };
    }
    // ----------------------------------------
    // TN EXCEPTION
    // BASED ON USER SELECTION LEFT OR RIGHT
    // ----------------------------------------
    if (featOrTv == 'left') {
      tn = {
        abbrev: 'TN',
        goodsAndServ: 25,
        resAtl: 25,
        resBtl: 25,
        nonResAtl: 0,
        nonResBtl: 0,
        minSpendFeature: 200000,
        capFeature: 0,
        minSpendTv: 500000,
        capTv: 0,
        msg: '',
      };
    } else {
      tn = {
        abbrev: 'TN',
        goodsAndServ: 25,
        resAtl: 25,
        resBtl: 25,
        nonResAtl: 25,
        nonResBtl: 25,
        minSpendFeature: 200000,
        capFeature: 0,
        minSpendTv: 500000,
        capTv: 0,
        msg: '',
      };
    }
    // ----------------------------------------
    // TX EXCEPTION
    // BASED ON TOTAL SPEND
    // ----------------------------------------
    let txTotal = totalSpend;
    if (txTotal <= 249999) {
      tx = {
        abbrev: 'TX',
        goodsAndServ: 0,
        resAtl: 0,
        resBtl: 0,
        nonResAtl: 0,
        nonResBtl: 0,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 0,
        capTv: 0,
        msg: '',
      };
    }
    if (txTotal >= 250000 && txTotal <= 999999) {
      tx = {
        abbrev: 'TX',
        goodsAndServ: 5,
        resAtl: 5,
        resBtl: 5,
        nonResAtl: 0,
        nonResBtl: 0,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 0,
        capTv: 0,
        msg: '',
      };
    }
    if (txTotal >= 1000000 && txTotal <= 3499999) {
      tx = {
        abbrev: 'TX',
        goodsAndServ: 10,
        resAtl: 10,
        resBtl: 10,
        nonResAtl: 0,
        nonResBtl: 0,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 0,
        capTv: 0,
        msg: '',
      };
    }
    if (txTotal >= 3500000) {
      tx = {
        abbrev: 'TX',
        goodsAndServ: 20,
        resAtl: 20,
        resBtl: 20,
        nonResAtl: 0,
        nonResBtl: 0,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 0,
        capTv: 0,
        msg: '',
      };
    }
    // ----------------------------------------
    // VA EXCEPTION
    // BASED ON TOTAL SPEND
    // ----------------------------------------
    let vaTotal = totalSpend;
    if (vaTotal <= 249999) {
      va = {
        abbrev: 'VA',
        goodsAndServ: 0,
        resAtl: 0,
        resBtl: 0,
        nonResAtl: 0,
        nonResBtl: 0,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 250000,
        capTv: 0,
        msg: '',
      };
    }
    if (vaTotal >= 250000 && vaTotal <= 999999) {
      va = {
        abbrev: 'VA',
        goodsAndServ: 15,
        resAtl: 25,
        resBtl: 25,
        nonResAtl: 15,
        nonResBtl: 15,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 250000,
        capTv: 0,
        msg: '',
      };
    }
    if (vaTotal >= 1000000) {
      va = {
        abbrev: 'VA',
        goodsAndServ: 25,
        resAtl: 35,
        resBtl: 35,
        nonResAtl: 25,
        nonResBtl: 25,
        minSpendFeature: 250000,
        capFeature: 0,
        minSpendTv: 250000,
        capTv: 0,
        msg: '',
      };
    }
    // ----------------------------------------
    const data = new Map();
    data.set('AL', al);
    data.set('AK', ak);
    data.set('AZ', az);
    data.set('AR', ar);
    data.set('CA1', ca1);
    data.set('CA2', ca2);
    data.set('CA3', ca3);
    data.set('CA4', ca4);
    data.set('CO', co);
    data.set('CT', ct);
    data.set('DC', dc);
    data.set('DE', de);
    data.set('FL', fl);
    data.set('GA', ga);
    data.set('HI', hi);
    data.set('ID', id);
    data.set('IL', il);
    data.set('INN', inn);
    data.set('IA', ia);
    data.set('KS', ks);
    data.set('KY', ky);
    data.set('LA', la);
    data.set('ME', me);
    data.set('MD', md);
    data.set('MA', ma);
    data.set('MI', mi);
    data.set('MN', mn);
    data.set('MS', ms);
    data.set('MO', mo);
    data.set('MT', mt);
    data.set('NE', ne);
    data.set('NV', nv);
    data.set('NH', nh);
    data.set('NJ', nj);
    data.set('NM', nm);
    data.set('NY', ny);
    data.set('NC', nc);
    data.set('ND', nd);
    data.set('OH', oh);
    data.set('OK', ok);
    data.set('OR', or);
    data.set('PA', pa);
    data.set('PR', pr);
    data.set('RI', ri);
    data.set('SC', sc);
    data.set('SD', sd);
    data.set('TN', tn);
    data.set('TX', tx);
    data.set('UT', ut);
    data.set('VT', vt);
    data.set('VA', va);
    data.set('WA', wa);
    data.set('WD', wd);
    data.set('WI', wi);
    data.set('WY', wy);
    calculateAndDisplayIncentivesForState(data.get(state));
  }

  // ----------------------------------------
  // CALCULATE AND DISPLAY INCENTIVES FOR STATE
  // ----------------------------------------
  /* void */ function calculateAndDisplayIncentivesForState(stateObject) {
    // ----------------------------------------
    // DISPLAY SPECIFIC OPTIONS AND MESSAGES
    // ----------------------------------------
    let displayOption = false;
    let optionLabelLeft = 'Feature';
    let optionLabelRight = 'TV';
    switch (stateObject.abbrev) {
      case 'MN':
        displayOption = true;
        optionLabelLeft = 'Rebate';
        optionLabelRight = 'Transferable Tax Credit';
        break;
      case 'DC':
        displayOption = true;
        optionLabelLeft = 'Within District';
        optionLabelRight = 'Outside District';
        break;
      case 'LA':
      case 'MD':
      case 'NC':
      case 'TN':
        displayOption = true;
        break;
      default:
        break;
    }

    // ----------------------------------------
    // CHECK MIN SPEND AND CAP
    // ----------------------------------------
    let min = 0;
    let cap = 0;
    switch (getRadioValue()) {
      case 'left':
        min = stateObject.minSpendFeature;
        cap = stateObject.capFeature;
        break;
      case 'right':
        min = stateObject.minSpendTv;
        cap = stateObject.capTv;
        break;
      default:
        min = stateObject.minSpendFeature;
        cap = stateObject.capFeature;
        break;
    }
    // ----------------------------------------
    // GET QUALIFIED SPEND VALUES FROM UI
    // AND CALCULATE TOTAL SPEND
    // ----------------------------------------
    let qsGoodsAndServ = parseFloat(
      document
        .getElementById('qsGoodsAndServ')
        .value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let qsResAtl = parseFloat(
      document
        .getElementById('qsResAtl')
        .value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let qsResBtl = parseFloat(
      document
        .getElementById('qsResBtl')
        .value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let qsNonResAtl = parseFloat(
      document
        .getElementById('qsNonResAtl')
        .value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );
    let qsNonResBtl = parseFloat(
      document
        .getElementById('qsNonResBtl')
        .value.replace(/\$/g, '')
        .replace(/,/g, ''),
    );

    qsGoodsAndServ = !isNaN(qsGoodsAndServ) ? qsGoodsAndServ : 0;
    qsResAtl = !isNaN(qsResAtl) ? qsResAtl : 0;
    qsResBtl = !isNaN(qsResBtl) ? qsResBtl : 0;
    qsNonResAtl = !isNaN(qsNonResAtl) ? qsNonResAtl : 0;
    qsNonResBtl = !isNaN(qsNonResBtl) ? qsNonResBtl : 0;

    let tot = qsGoodsAndServ + qsResAtl + qsResBtl + qsNonResAtl + qsNonResBtl;

    // ----------------------------------------
    // DISPLAY MIN CAP STATUS
    // DECIDE IF SHOULD DISPLAY ESTIMATE
    // ----------------------------------------
    // ONLY DISPLAY ESTIMATE IF ABOVE MIN AND
    // BELOW CAP
    // ----------------------------------------
    /* bool   */ let displayEstimate = false;
    /* string */ let spendAlert = '';
    if (min != 0 && tot <= min) {
      spendAlert =
        'Minimum Spend not met ($' +
        min.toLocaleString(undefined, { minFractionDigits: 0 }) +
        ')';
    }
    if (min == 0 || (min != 0 && tot >= min)) {
      spendAlert =
        'Minimum Spend reached ($' +
        min.toLocaleString(undefined, { minFractionDigits: 0 }) +
        ')';
      displayEstimate = true;
    }
    if (min == 0) {
      spendAlert = 'No minimum spend';
    }
    /* int */ let total = '0';
    if (displayEstimate) {
      // ----------------------------------------
      // CALCULATE PERCENTAGES BASED ON STATE
      // ARRAY AND DISPLAY IN UI
      // ALSO DISPLAY PERCENTAGE VALUE FROM
      // ARRAY IN PARENTHESIS FOLLOWED BY A %
      // ----------------------------------------

      // ----------------------------------------
      // DISPLAY ESTIMATED TOTAL SAVINGS
      // ----------------------------------------
      /* int */ let estimatedSavings =
        (qsGoodsAndServ * stateObject.goodsAndServ) / 100 +
        (qsResAtl * stateObject.resAtl) / 100 +
        (qsResBtl * stateObject.resBtl) / 100 +
        (qsNonResAtl * stateObject.nonResAtl) / 100 +
        (qsNonResBtl * stateObject.nonResBtl) / 100;
      // NEVER GO ABOVE CAP
      if (cap != 0 && estimatedSavings >= cap) {
        estimatedSavings = cap;
        spendAlert =
          'Project Cap reached ($' +
          cap.toLocaleString(undefined, { minFractionDigits: 0 }) +
          ')';
      }
      total = estimatedSavings ? estimatedSavings.toLocaleString() : '0';
    } else {
      // LEAVE TOTAL AS 0
    }
    setOutput({
      ...output,
      displayOption_r: displayOption,
      optionLabelLeft_r: optionLabelLeft,
      optionLabelRight_r: optionLabelRight,
      state_r: stateObject.abbrev,
      message_r: stateObject.msg,
      spendAlert_r: spendAlert,
      minSpendFeature_r: stateObject.minSpendFeature,
      capFeature_r: stateObject.capFeature,
      minSpendTv_r: stateObject.minSpendTv,
      capTv_r: stateObject.capTv,
      qsGoodsAndServ_r: qsGoodsAndServ ? qsGoodsAndServ.toLocaleString() : '0',
      qsResAtl_r: qsResAtl ? qsResAtl.toLocaleString() : '0',
      qsResBtl_r: qsResBtl ? qsResBtl.toLocaleString() : '0',
      qsNonResAtl_r: qsNonResAtl ? qsNonResAtl.toLocaleString() : '0',
      qsNonResBtl_r: qsNonResBtl ? qsNonResBtl.toLocaleString() : '0',
      goodsAndServ_r:
        (
          (qsGoodsAndServ ? qsGoodsAndServ * stateObject.goodsAndServ : 0) / 100
        ).toLocaleString(undefined, { minFractionDigits: 0 }) +
        ' (' +
        stateObject.goodsAndServ +
        '%)',
      resAtl_r:
        (
          (qsResAtl ? qsResAtl * stateObject.resAtl : 0) / 100
        ).toLocaleString(undefined, { minFractionDigits: 0 }) +
        ' (' +
        stateObject.resAtl +
        '%)',
      resBtl_r:
        (
          (qsResBtl ? qsResBtl * stateObject.resBtl : 0) / 100
        ).toLocaleString(undefined, { minFractionDigits: 0 }) +
        ' (' +
        stateObject.resBtl +
        '%)',
      nonResAtl_r:
        (
          (qsNonResAtl ? qsNonResAtl * stateObject.nonResAtl : 0) / 100
        ).toLocaleString(undefined, { minFractionDigits: 0 }) +
        ' (' +
        stateObject.nonResAtl +
        '%)',
      nonResBtl_r:
        (
          (qsNonResBtl ? qsNonResBtl * stateObject.nonResBtl : 0) / 100
        ).toLocaleString(undefined, { minFractionDigits: 0 }) +
        ' (' +
        stateObject.nonResBtl +
        '%)',
      total_r: total,
    });
    qsGoodsAndServ &&
      (document.getElementById('qsGoodsAndServ').value = addComma(
        qsGoodsAndServ,
      ));
    qsResAtl &&
      (document.getElementById('qsResAtl').value = addComma(qsResAtl));
    qsResBtl &&
      (document.getElementById('qsResBtl').value = addComma(qsResBtl));
    qsNonResAtl &&
      (document.getElementById('qsNonResAtl').value = addComma(qsNonResAtl));
    qsNonResBtl &&
      (document.getElementById('qsNonResBtl').value = addComma(qsNonResBtl));
  }

  // ----------------------------------------
  // ADD COMMA
  // ----------------------------------------
  /* number */ function addComma(num) {
    num += '';
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    num = num.replace(',', '');
    let x = num.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) x1 = x1.replace(rgx, '$1' + ',' + '$2');
    return '$' + x1 + x2;
  }

  // ----------------------------------------
  // HANLDE FIELD CHANGE
  // ----------------------------------------
  function handleFieldChange(value: string) {
    defineIncentivesForState(output.state_r);
  }

  // ----------------------------------------
  // HANLDE MENU STYLE
  // ----------------------------------------
  function handleMenuStyle(menu: HTMLSelectElement) {
    if (
      menu.getAttribute('style') == 'color: black; background-color: white;'
    ) {
      menu.setAttribute('style', 'color: white; background-color: #868686;');
    } else {
      menu.setAttribute('style', 'color: black; background-color: white;');
    }
  }

  return (
    <StyledContainer>
      <div id="controls">
        <form>
          <div id="controlsInner">
            <h1>Enter qualified spend only</h1>
            <div className="option">
              <select
                name="state"
                id="state"
                style={{ color: 'black', backgroundColor: 'white' }}
                onMouseOut={event => handleMenuStyle(event.target)}
                onMouseOver={event => handleMenuStyle(event.target)}
                onChange={event =>
                  event.target[event.target.options.selectedIndex].value != ''
                    ? defineIncentivesForState(
                        event.target[event.target.options.selectedIndex].value,
                      )
                    : null
                }
              >
                <option value="">SELECT JURISDICTION</option>
                <option value="AL">Alabama</option>
                <option value="AK" disabled>
                  Alaska
                </option>
                <option value="AZ" disabled>
                  Arizona
                </option>
                <option value="AR">Arkansas</option>
                <option value="CA1">California - Independent</option>
                <option value="CA2">California - Feature Films</option>
                <option value="CA3">California - Relocating TV</option>
                <option value="CA4">California - TV Projects</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE" disabled>
                  Delaware
                </option>
                <option value="DC">District Of Columbia</option>
                <option value="FL" disabled>
                  Florida
                </option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID" disabled>
                  Idaho
                </option>
                <option value="IL">Illinois</option>
                <option value="INN">Indiana</option>
                <option value="IA" disabled>
                  Iowa
                </option>
                <option value="KS" disabled>
                  Kansas
                </option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI" disabled>
                  Michigan
                </option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO" disabled>
                  Missouri
                </option>
                <option value="MT">Montana</option>
                <option value="NE" disabled>
                  Nebraska
                </option>
                <option value="NV">Nevada</option>
                <option value="NH" disabled>
                  New Hampshire
                </option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND" disabled>
                  North Dakota
                </option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="PR">Puerto Rico</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD" disabled>
                  South Dakota
                </option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT" disabled>
                  Vermont
                </option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV" disabled>
                  West Virginia
                </option>
                <option value="WI" disabled>
                  Wisconsin
                </option>
                <option value="WY" disabled>
                  Wyoming
                </option>
              </select>
            </div>
            <StyledTextField
              placeholder={
                output.qsGoodsAndServ_r != '0'
                  ? 'GOODS AND SERVICES'
                  : '$0 GOODS AND SERVICES'
              }
              type="text"
              id="qsGoodsAndServ"
              onFocus={event => (event.target.value = '')}
              onChange={event => handleFieldChange(event.target.value)}
              disabled={output.state_r != '' ? false : true}
            />
            <StyledTextField
              placeholder={
                output.qsResAtl_r != '0' ? 'RESIDENT ATL' : '$0 RESIDENT ATL'
              }
              type="text"
              id="qsResAtl"
              onFocus={event => (event.target.value = '')}
              onChange={event => handleFieldChange(event.target.value)}
              disabled={output.state_r != '' ? false : true}
            />
            <StyledTextField
              placeholder={
                output.qsResBtl_r != '0' ? 'RESIDENT BTL' : '$0 RESIDENT BTL'
              }
              type="text"
              id="qsResBtl"
              onFocus={event => (event.target.value = '')}
              onChange={event => handleFieldChange(event.target.value)}
              disabled={output.state_r != '' ? false : true}
            />
            <StyledTextField
              placeholder={
                output.qsNonResAtl_r != '0'
                  ? 'NON-RESIDENT ATL'
                  : '$0 NON-RESIDENT ATL'
              }
              type="text"
              id="qsNonResAtl"
              onFocus={event => (event.target.value = '')}
              onChange={event => handleFieldChange(event.target.value)}
              disabled={output.state_r != '' ? false : true}
            />
            <StyledTextField
              placeholder={
                output.qsNonResBtl_r != '0'
                  ? 'NON-RESIDENT BTL'
                  : '$0 NON-RESIDENT BTL'
              }
              type="text"
              id="qsNonResBtl"
              onFocus={event => (event.target.value = '')}
              onChange={event => handleFieldChange(event.target.value)}
              disabled={output.state_r != '' ? false : true}
            />
          </div>
        </form>
      </div>
      <div id="results">
        <div id="resultsInner">
          <h1>Incentive Amount</h1>
          <div className="option">
            {output.displayOption_r && (
              <p>
                <input
                  type="radio"
                  name="option"
                  value="left"
                  onChange={event => defineIncentivesForState(output.state_r)}
                />
                &nbsp;{output.optionLabelLeft_r}&nbsp;&nbsp;
                <input
                  type="radio"
                  name="option"
                  value="right"
                  onChange={event => defineIncentivesForState(output.state_r)}
                />
                &nbsp;{output.optionLabelRight_r}
              </p>
            )}
          </div>
          <hr />
          <p className="result">${output.goodsAndServ_r} GOODS AND SERVICES</p>
          <hr />
          <p className="result">${output.resAtl_r} RESIDENT ATL</p>
          <hr />
          <p className="result">${output.resBtl_r} RESIDENT BTL</p>
          <hr />
          <p className="result">${output.nonResAtl_r} NON-RESIDENT ATL</p>
          <hr />
          <p className="result">${output.nonResBtl_r} NON-RESIDENT BTL</p>
          <hr />
        </div>
      </div>
      <div id="bottom">
        <div className="spendAlertCell">
          <p className="spendAlert">{output.spendAlert_r}</p>
        </div>
        <div className="estimatedSavingsCell">
          <div className="estimatedSavings">Estimated Savings</div>
          <div className="total">${output.total_r}</div>
        </div>
        <div>
          <div id="messageDiv" className="msg">
            {output.message_r}
          </div>
        </div>
      </div>
    </StyledContainer>
  );
}

export default React.memo(IncentiveEstimatorModuleUS);
